<template>
  <div id="faz-corona-dashboard" v-if="!loading">
    <div class="headline">Das Coronavirus in Deutschland</div>
    <!-- <p class="subheadline">Stand: </p> -->
    <div class="">
      <div class="row">
        <div class="column">
          <div class="overlineBox">
            <div class="headline">
              7-Tage-Inzidenz
            </div>
            <div class="number" style="color:#ED7D38">{{ cases.incidence }}</div>
            <div class="subheadline">
              Neue Fälle pro 100.000 Einwohner in den letzten sieben Tagen
            </div>
            <div class="chart">
              <LineChart
                :height="200"
                :colors="['#ED7D38']"
                :data="cases.incidence_history.slice(1)"
              />
              <!-- :yRange="[0,500]" -->
            </div>
          </div>
          <div class="statBox">
            <div class="stat">
              Gestern gemeldete Infektionsfälle
            </div>
            <div class="number" style="color:#ED7D38">+{{ cases.cases_new }}</div>
          </div>
          <div class="statBox">
            <div class="stat">
              Infektionsfälle insgesamt
            </div>
            <div class="number" style="color:#ED7D38">{{ cases.cases_total }}</div>
          </div>
        </div>
        <div class="column">
          <div class="overlineBox">
            <div class="headline">
              Todesfälle
            </div>
            <div class="number" style="color:#D13D3D">{{ deaths.deaths_avg }}</div>
            <div class="subheadline">
              7-Tage-Mittelwert
            </div>
            <div class="chart">
              <LineChart
                :height="200"
                :colors="['#D13D3D']"
                :data="deaths.deaths_history.slice(1)"
              />
              <!-- :yRange="[0,1000]" -->
              <!-- <LineChart
                :data="[['dateFormat?','Column A','Column B'], [1,0,5],[2,9,4],[3,1,6],[4,8,3],[5,2,7],[6,7,3],[7,3,6],[8,6,4],[9,4,5],[10,5,1]]"
              /> -->
            </div>
          </div>
          <div class="statBox">
            <div class="stat">
              Gestern gemeldete Todesfälle
            </div>
            <div class="number" style="color:#D13D3D">+{{ deaths.deaths_new }}</div>
          </div>
          <div class="statBox">
            <div class="stat">
              Todesfälle insgesamt
            </div>
            <div class="number" style="color:#D13D3D">{{ deaths.deaths_total }}</div>
          </div>
        </div>
      </div>
    </div>
    <p class="footnote">{{ meta.timestamp }}<br>{{ meta.source }}<br></p>
  </div>
</template>

<script>
// import LineChart from '/Users/j.giesel/vsts/FAZ Vue Chart Library/src/components/LineChart.vue'
import LineChart from '@/components/LineChart.vue'

export default {
  name: 'faz-corona-dashboard',
  components: {
    LineChart,
  },
  data () {
    return {
      intensive_care_beds: null,
      vaccinations: null,
      incidence: null,
      cases: null,
      deaths: null,
      meta: null,
      chartReady: false,
      loading: true,
      chartOptions: {
        height: 160,
        colors: ["#D13D3D"],
        fontSize: 14,
        fontName: "'FAZ Gold', Helvetica, Arial, sans-serif",
        lineWidth: 3,
        curveType: 'function',
        animation: {
          startup: true,
          duration: 1000,
          easing: 'out'
        },
        hAxis: {
          ticks: [],
          textPosition: 'none'
        },
        vAxis: {
          textStyle: {
            color: '#666'
          },
          gridlines: {
            count: 5,
            color: '#efefef'
          },
          minorGridlines: {
            count: 0
          }
        },
        legend: {
          position: 'none' 
        },
        tooltip: {
          isHtml: true
        }
      },
      chart1: {
        colors: ["#ED7D38"],
        chartArea: {left:30,top:10,width:'99%',height:'90%'},
      },
      chart2: {
        colors: ["#D13D3D"],
        chartArea: {left:38,top:10,width:'99%',height:'90%'},
      },
      // chart3: {
      //   colors: ["#A5CE81", "#6FA746", "#0C9941"],
      //   chartArea: {left:0,top:10,width:'99%',height:'100%'},
      // }
    }
  },
  mounted () {
    const cases_url = process.env.NODE_ENV == 'development' ? 
      'data/cases_deaths_ger.json' :
      // 'https://dynamic.faz.net/red/2020/coronavirus/fallzahlen-deutschland/data/cases_deaths_ger.json'
      'https://cdn.faz-azure.com/multimediaredaktion/corona/cases_deaths_ger.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D'

    let fetches = [
      fetch(cases_url).then(r => r.json()),
    ]
    Promise.all(fetches).then((results) => {
      this.cases = results[0].cases
      this.deaths = results[0].deaths
      this.meta = results[0].meta

      this.loading = false
    })
  },
  updated () {
    // pymChild.sendHeight()
    // console.log(pymChild)
  },
  methods: {
    getLatest () {
      let today = new Date()
      return String(today.getDate()).padStart(2, '0') + '.' + String(today.getMonth() + 1).padStart(2, '0') + '.' + today.getFullYear()

      // let a = this.incidence.slice(-1)[0][0].slice(3,5) + this.incidence.slice(-1)[0][0].slice(0,2)
      // let b = this.intensive_care_beds.slice(-1)[0][0].slice(3,5) + this.intensive_care_beds.slice(-1)[0][0].slice(0,2)
      // let c = this.vaccinations.slice(-1)[0][0].slice(3,5) + this.vaccinations.slice(-1)[0][0].slice(0,2)

      // // return [parseInt(a),parseInt(b),parseInt(c)]
      // return Math.max(parseInt(a),parseInt(b),parseInt(c))
    },
    onChartReady () {
      setTimeout( () => this.chartReady = true, 500)
      
      // setTimeout( () => pymChild.sendHeight(), 1000)
      // setTimeout( () => console.log('onChartReady'), 1000)
    }
  },
  watch: {
  },
  computed: {
    chartOptions1 () {
      return {...this.chartOptions, ...this.chart1 }
    },
    chartOptions2 () {
      return {...this.chartOptions, ...this.chart2 }
    }
  }
}
</script>

<!--style scoped src="./assets/foundation.css">
</style-->

<style scoped lang="scss">
// @import './assets/foundation.css';
@import './assets/style.scss';
</style>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

div.google-visualization-tooltip {
  border: none !important;
  padding: 4px 10px !important;
  position: absolute !important;
  color: #ffffff !important;
  font-size: 14px !important;
  line-height: 1.3 !important;
  background: #363636 !important;
  border-radius: 2px !important;
  pointer-events: none !important;
  -webkit-box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;
  -moz-box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;
  box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;

  ul {
    margin: 0 !important;
    padding: 0 !important;

    li {
      margin: 0 !important;
      padding: 0 !important;

      span {
        margin: 0 !important;
        padding: 0 !important;
        color: #fff !important;
        line-height: 1.5;
      }
    }
  }
}
.ctn-PlaceholderContent {
    overflow: visible;
}
</style>